import React, { useEffect, useState } from "react";
import { ReactComponent as DeleteIcon } from "../../VNCViewer/assets/delete-session.svg";
import { ReactComponent as Delete2Icon } from "../../../assets/icons/deleteIcon.svg";
import { ReactComponent as SnapshotIcon } from "../../VNCViewer/assets/snapshot.svg";
import { ReactComponent as StreamIcon } from "../../VNCViewer/assets/stream.svg";
import { ReactComponent as SettingIcon } from "../../VNCViewer/assets/setting.svg";
import { ReactComponent as FeedbackIcon } from "../../VNCViewer/assets/feedback.svg";
import { ReactComponent as AudioIcon } from "../../VNCViewer/assets/audio.svg";
import { ReactComponent as FileTransferIcon } from "../../VNCViewer/assets/file-trasnfer.svg";
import { ReactComponent as FullScreenIcon } from "../../VNCViewer/assets/full-screen.svg";
import { ReactComponent as MicroIcon } from "../../VNCViewer/assets/micro.svg";
import { ReactComponent as CopyPastIcon } from "../../VNCViewer/assets/copy-past.svg";
import { ReactComponent as CompressionIcon } from "../../VNCViewer/assets/stream.svg"; // Reusing stream icon for compression temporarily
import { ReactComponent as ScalingIcon } from "../../VNCViewer/assets/full-screen.svg"; // Reusing fullscreen icon for scaling temporarily
import { ReactComponent as DownIcon } from "../../../assets/icons/fi_down.svg";
import { useDispatch, useSelector } from "react-redux";
import { deleteSession } from "../../../data/slices/sessions";
import { useLocation, useNavigate } from "react-router-dom";
import { Modal, Popover, Tooltip, Dropdown, Menu, message } from "antd";
import { openModal } from "../../../data/slices/modals";
import FeatureProvider from "../../../providers/FeaturesProvider/FeatureProvider";
import { store } from "../../../data";
import { getSnapshots } from "../../../data/slices/snapshot";
import { useTranslation } from "react-i18next";
import { useFlags } from "flagsmith/react";
import { DownOutlined } from "@ant-design/icons";
import {
  snapshot_modal_flag,
  stream_quality_flag,
  file_transfer_flag,
  clipboard_flag,
  audio_flag,
  microphone_flag,
  full_screen_flag,
  feedback_flag
} from "../../../constants/flagsmith";

const ClipboardArea = () => {
  const { sessionClipboardText } = useSelector((state) => state.settings);

  return (
    <div className="copy-paste-popover">
      <p>Clipboard History</p>
      <div className="textarea">
        {sessionClipboardText?.map((string, index) => {
          return (
            <Tooltip key={index} title={string}>
              <div>{string}</div>
            </Tooltip>
          );
        })}
      </div>
    </div>
  );
};

const ProxySideNav = ({ session, vncActions, vncStates, ...props }) => {
  const { t } = useTranslation("other");
  const { currentPlan } = useSelector((state) => state.currentPlan);
  const searchParams = new URLSearchParams(document.location.search);
  const type = searchParams.get("type");

  const isFullScreen = document.fullscreenElement && document.webkitFullscreenElement;
  const { isClipboardEnabled } = useSelector((state) => state.settings);
  const { audioEnabled, recordingEnabled } = useSelector((state) => state.sessions);
  const { confirm } = Modal;
  const [navIsOpen, setNavOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const closeSidenav = () => setNavOpen(false);

  const flags = useFlags([
    snapshot_modal_flag,
    stream_quality_flag,
    file_transfer_flag,
    clipboard_flag,
    audio_flag,
    microphone_flag,
    full_screen_flag,
    feedback_flag
  ]);

  useEffect(() => {
    dispatch(getSnapshots({}));
  }, []);

  const showDeleteConfirm = () => {
    closeSidenav();
    confirm({
      centered: true,
      title: t("other-15"),
      content: "",
      okText: t("other-16"),
      okType: "danger",
      cancelText: t("other-17"),
      maskClosable: true,
      wrapClassName: "modal_delete_multiple",
      icon: (
        <div className="delete-model-icon">
          <Delete2Icon />
        </div>
      ),
      async onOk() {
        dispatch(deleteSession({ name: session.name, namespace: session.namespace }));

        // if Lti user then logout him
        if (pathname.includes(session.name)) {
          navigate("/");
        }
      },
      onCancel() {
        console.log("Cancel");
      },
      autoFocusButton: "cancel"
    });
  };

  // Helper function to get scaling mode label
  const getScalingModeLabel = (mode) => {
    switch (mode) {
      case "scale":
        return "Local Scaling";
      case "remote":
        return "Remote Resizing";
      case "off":
      default:
        return "No Scaling";
    }
  };

  // Scaling mode dropdown menu items
  const scalingItems = [
    {
      key: "off",
      label: "No Scaling"
    },
    {
      key: "scale",
      label: "Local Scaling"
    },
    {
      key: "remote",
      label: "Remote Resizing"
    }
  ];

  // Handle scaling mode selection
  const handleScalingModeChange = ({ key }) => {
    if (vncActions.setScalingMode) {
      vncActions.setScalingMode(key);
      message.success(`Scaling mode changed to ${getScalingModeLabel(key)}`);
      closeSidenav();
    }
  };

  return (
    <>
      {navIsOpen ? (
        <div className="vnc-sidenav-overlay" onClick={closeSidenav} tabIndex={-1}></div>
      ) : null}
      <div className={`vnc-sidenav ${!navIsOpen ? "vnc-sidenav-hide" : ""}`}>
        <div className="vnc-sidenav-toggle-button" onClick={() => setNavOpen(!navIsOpen)}>
          <SettingIcon />
        </div>

        {type !== "demo" && (
          <FeatureProvider
            status={flags?.[snapshot_modal_flag]?.enabled && currentPlan?.snapshotFeature?.isOn}
            type="hide"
          >
            <div
              className="vnc-sidenav-item"
              onClick={() => dispatch(openModal("snapshot-modal", { sessionId: session.name }))}
            >
              <SnapshotIcon />
              <p>Snapshot</p>
            </div>
          </FeatureProvider>
        )}

        <FeatureProvider status={flags?.[stream_quality_flag]?.enabled} type="hide">
          <div
            className="vnc-sidenav-item"
            onClick={() => {
              closeSidenav();
              dispatch(
                openModal("stream-quality-modal", {
                  onQualityChange: vncActions.setQuality,
                  currentLevel: vncActions.getQuality(),
                  type: "stream-quality"
                })
              );
            }}
          >
            <StreamIcon />
            <p>Stream Quality</p>
          </div>
        </FeatureProvider>

        {/* Compression Settings Button */}
        <div
          className="vnc-sidenav-item"
          onClick={() => {
            closeSidenav();
            dispatch(
              openModal("stream-quality-modal", {
                onQualityChange: vncActions.setCompression,
                currentLevel: vncActions.getCompressionLevel(),
                type: "compression"
              })
            );
          }}
        >
          <CompressionIcon />
          <p>Compression Level</p>
        </div>

        {/* Scaling Mode Dropdown */}
        <Dropdown
          menu={{
            items: scalingItems,
            onClick: handleScalingModeChange,
            selectedKeys: [vncStates?.scalingMode || "off"]
          }}
          trigger={["click"]}
        >
          <div className="vnc-sidenav-item">
            <ScalingIcon />
            <p>Scaling Mode</p>
            <DownIcon />
          </div>
        </Dropdown>

        {/* {type !== "demo" && (
          <FeatureProvider status={flags?.[file_transfer_flag]?.enabled} type="hide">
            <div
              className="vnc-sidenav-item"
              onClick={() => {
                vncActions.onUploadFile();
              }}
            >
              <FileTransferIcon />
              <p>File Transfer</p>
            </div>
          </FeatureProvider>
        )} */}

        {/* <FeatureProvider status={flags?.[clipboard_flag]?.enabled} type="hide">
          <Popover
            placement="rightTop"
            trigger={"click"}
            content={<ClipboardArea navIsOpen={navIsOpen} />}
          >
            <div
              className={`vnc-sidenav-item ${!isClipboardEnabled ? "active-item" : "active-item"}`}
            >
              <CopyPastIcon />
              <p>Copy Paste</p>
            </div>
          </Popover>
        </FeatureProvider> */}

        {/* <FeatureProvider status={flags?.[audio_flag]?.enabled} type="hide">
          <div
            className={`vnc-sidenav-item ${audioEnabled ? "active-item" : ""}`}
            onClick={() => {
              vncActions.handleToggleAudio();
            }}
          >
            <AudioIcon />
            <p>Audio</p>
          </div>
        </FeatureProvider> */}

        {/* <FeatureProvider status={flags?.[microphone_flag]?.enabled} type="hide">
          <div
            className={`vnc-sidenav-item ${recordingEnabled ? "active-item" : ""}`}
            onClick={() => {
              vncActions.handleToggleMicro();
            }}
          >
            <MicroIcon />
            <p>Microphone</p>
          </div>
        </FeatureProvider> */}

        {type !== "demo" && (
          <FeatureProvider status={flags?.[full_screen_flag]?.enabled} type="hide">
            <div
              className={`vnc-sidenav-item ${isFullScreen !== null ? "active-item" : ""}`}
              onClick={() => {
                vncActions.onFullScreen();
              }}
            >
              <FullScreenIcon />
              <p>Full Screen</p>
            </div>
          </FeatureProvider>
        )}
        <FeatureProvider status={flags?.[feedback_flag]?.enabled} type="hide">
          <div
            className="vnc-sidenav-item"
            onClick={() => {
              closeSidenav();
              vncActions.handleToggleFeedback();
            }}
          >
            <FeedbackIcon />
            <p>Feedback</p>
          </div>
        </FeatureProvider>
        {type !== "demo" && (
          <div className="vnc-sidenav-item" onClick={showDeleteConfirm}>
            <DeleteIcon />
            <p>Delete Session</p>
          </div>
        )}
      </div>
    </>
  );
};

export default ProxySideNav;
